export const ADMIN_SCREEN_CREATION_MODE = 'CREATION_MODE';
export const ADMIN_SCREEN_EDIT_MODE = 'EDIT_MODE';